var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "calendar_today"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1929_9069",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1929_9069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "calendar_today_2",
    d: "M5.61538 21.0003C5.15513 21.0003 4.77083 20.8461 4.4625 20.5378C4.15417 20.2295 4 19.8452 4 19.3849V6.61568C4 6.15543 4.15417 5.77114 4.4625 5.46281C4.77083 5.15447 5.15513 5.00031 5.61538 5.00031H7.3846V2.76953H8.46152V5.00031H15.6154V2.76953H16.6154V5.00031H18.3846C18.8449 5.00031 19.2292 5.15447 19.5375 5.46281C19.8458 5.77114 20 6.15543 20 6.61568V19.3849C20 19.8452 19.8458 20.2295 19.5375 20.5378C19.2292 20.8461 18.8449 21.0003 18.3846 21.0003H5.61538ZM5.61538 20.0003H18.3846C18.5385 20.0003 18.6795 19.9362 18.8077 19.808C18.9359 19.6798 19 19.5388 19 19.3849V10.6157H5V19.3849C5 19.5388 5.0641 19.6798 5.1923 19.808C5.32052 19.9362 5.46154 20.0003 5.61538 20.0003ZM5 9.61568H19V6.61568C19 6.46185 18.9359 6.32082 18.8077 6.19261C18.6795 6.06441 18.5385 6.00031 18.3846 6.00031H5.61538C5.46154 6.00031 5.32052 6.06441 5.1923 6.19261C5.0641 6.32082 5 6.46185 5 6.61568V9.61568Z",
    fill: "#15B79E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.a23e0cce6ee5a3459251a3f1d9e9f0a1.svg";
export { ForwardRef as ReactComponent };